import React, { createContext, useState, use, ReactNode } from "react"

// Define Context Type
interface TitleContextType {
  dynamicMobileTitle: string | undefined;
  setDynamicMobileTitle: (dynamicMobileTitle: string | undefined) => void;
}

const TitleContext = createContext<TitleContextType | undefined>(undefined)

export const useDynamicMobileTitle = () => {
  const context = use(TitleContext)
  
  if (!context) {
    throw new Error("useDynamicMobileTitle must be used within a TitleProvider")
  }

  return context
}

interface TitleProviderProps {
  children: ReactNode;
}

export const TitleProvider: React.FC<TitleProviderProps> = ({ children }) => {
  const [dynamicMobileTitle, setDynamicMobileTitle] = useState<string | undefined>(undefined)

  return (
    <TitleContext value={{ dynamicMobileTitle, setDynamicMobileTitle }}>
      {children}
    </TitleContext>
  )
}
